<template>
    <div>
    <div class="select-box select-box-double" >
        <div class="select-box-current" v-ripple @click="toggleSelectBox">
            <span>FROM: {{ this.selectedFromItem ? this.selectedFromItem.text : '' }} </span>
            <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
        </div>
        <div class="select-box-open" :class="{ open }">
            <div class="select-box-separator"></div>
            <div class="select-box-items">
                <div class="select-box-item" v-for="item in invertedItems" :key="item.value" @click="selectFromItem(item)" v-ripple>
                    <i class="fa fa-check" :class="{ visible: selectedFromValue === item.value }"></i>
                    <span>From: {{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
    <div class="select-box">
        <div class="select-box-current" v-ripple @click="toggleSelectBox">
            <span>TO: {{ this.selectedToItem ? this.selectedToItem.text : '' }} </span>
            <i class="fa" :class="{ 'fa-chevron-down': !open, 'fa-chevron-up': open }"></i>
        </div>
        <div class="select-box-open" :class="{ open }">
            <div class="select-box-separator"></div>
            <div class="select-box-items">
                <div class="select-box-item" v-for="item in items" :key="item.value" @click="selectToItem(item)" v-ripple>
                    <i class="fa fa-check" :class="{ visible: selectedToValue === item.value }"></i>
                    <span>To: {{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>

export default {
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: String,
        },

    },
    watch: {
        fromValue() {
            this.setDefaultSelectedValue();
        },
        toValue() {
            this.setDefaultSelectedValue();
        },
        value() {
            this.setDefaultSelectedValue();
        },
    },
    computed: {
        selectedFromItem() {
            return this.items.find(item => item.value === this.selectedFromValue);
        },
        selectedToItem() {
            return this.items.find(item => item.value === this.selectedToValue);
        },
        invertedItems() {
            return this.items.slice().reverse();
        },

    },
    data() {
        return {
            selectedFromValue: null,
            selectedToValue: null,
            open: false,
        };
    },
    created() {

        this.setDefaultSelectedValue();
    },
    methods: {
        setDefaultSelectedValue() {
            this.selectedFromValue= this.value ?  this.value.split(',')[0]:this.items[this.items.length - 1].value;
            this.selectedToValue= this.value ?  this.value.split(',')[1]:this.items[0].value;
            this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
            this.$emit('changeRevenueFilterRange', this.selectedFromValue+','+this.selectedToValue)
        },

        selectFromItem(item) {
            this.selectedFromValue = item.value;
            if(this.selectedFromValue>this.selectedToValue)this.selectedToValue = this.selectedFromValue;

            this.open = false;
            this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
            this.$emit('changeRevenueFilterRange', this.selectedFromValue+','+this.selectedToValue)

        },
        selectToItem(item) {
            this.selectedToValue = item.value;
            if(this.selectedFromValue>this.selectedToValue)this.selectedFromValue = this.selectedToValue;

            this.open = false;
            this.$emit('input', this.selectedFromValue+','+this.selectedToValue);
            this.$emit('changeRevenueFilterRange', this.selectedFromValue+','+this.selectedToValue)
        },
        toggleSelectBox() {
            this.open = !this.open;
        },
    },
};

</script>

<style lang="scss">
    @import '../../style/common/SelectBox.scss';
</style>
